import { LoadingContent } from './styles'

const Loading = () => {
  return (
    <LoadingContent>
      <div className="loading-block carousel"></div>
      <div className="loading-block modules"></div>
    </LoadingContent>
  )
}

export default Loading
